import * as React from 'react';
import styled from 'styled-components';

declare module '../Controls/hkt' {
    interface URIControlsToKind {
        'switch': ISwitchProps
    }
}

const Control = styled.input.attrs(_ => ({
    type: 'checkbox'
}))`
    border: .5px solid;
    background-color: #e8e8e8;
    border-radius: 30px;
    position: relative;
    appearance: none;
    cursor: pointer;
    border-color: transparent;
    width: 2em;
    height: 1em;
    margin: auto 0;

    &:after {
        content: '';
        display: block;
        position: absolute;
        border-radius: 50%;
        top: 50%;
        background: #fff;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
        transition: all .33s ease-in-out;
        width: .65em;
        height: .65em;
    }

    &:checked:after {
        left: calc(100% - .2em);
        transform: translate(-100%, -50%);
    }

    &:not(:checked):after {
        left: .2em;
        transform: translate(0, -50%);
    }

    &:not(:disabled):hover  {
        border-color: #CECECE;
    }

    &:disabled {
        cursor: default;
    }

    &:checked {
        background-color: #98a9bc;

        &:hover {
            background-color: #8794A3;
        }

        &:disabled {
            background-color: #C1CCD8;

            &:after {
                background-color: #C1CCD8;
            }
        }
    }

    &:not(:checked):disabled {
        background-color: #F2F3F4;

        &:after {
            background-color: #E7EAEE;
        }
    }
`;


type ISwitchProps = {
    name: string,
    onChange: (value: { [key: string]: boolean }, name: string, e: React.ChangeEvent<HTMLInputElement>) => void,
    disabled?: boolean,
    className?: string,
    value: string,
    checked: boolean,
}

const Switch = React.forwardRef<HTMLInputElement, ISwitchProps>(({ 
    name, 
    disabled = false, 
    onChange,
    className,
    value,
    checked,
}, ref) => {

    const selfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const x = e.target.checked;

        onChange({ [value]: x }, name, e);
    }

    return (
        <Control
            name={name}
            disabled={disabled}
            onChange={selfChange}
            className={className}
            value={value}
            defaultChecked={checked}
            ref={ref}
        />
    );
});

export default Switch;
